<span class="mention" [matMenuTriggerFor]="menu">
  {{ mentionTrigger }}<ng-content></ng-content>
</span>
<mat-menu
  #menu="matMenu"
  xPosition="after"
  yPosition="below"
  [overlapTrigger]="false"
>
  <button
    *ngFor="let action of actions; trackBy: trackByAction"
    mat-menu-item
    (click)="runAction(action)"
  >
    <mat-icon>{{ action.icon }}</mat-icon>
    {{ action.name }}
  </button>
</mat-menu>
